import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";

const UPDATES = [
  ["4 Nov 2026", "Driving Mode answers can now run up to 4 minutes."],
  ["4 Nov 2026", "Test microphone pop-up with a live sound bar; fixed long answers on laptops showing \"No answer recorded\"."],
  ["Nov 2026", "Performance Summary: grades over time, safety verdicts, most-missed basics, mock day results and exam readiness."],
  ["Nov 2026", "Mock Exam Day: 8 back-to-back stations with a break after 4, marked on the three ANZCA pass rules."],
  ["Nov 2026", "Driving Mode recent attempts, and every driving question now stands alone."],
  ["Nov 2026", "Exam Prep Advice page (tips courtesy of Dr Greg Coates) and a Notes box during reading time."],
  ["Nov 2026", "Cases checked against the official Scenarioville resources (e.g. BIS and sugammadex are available)."],
];

const Updates = () => (
  <section data-testid="about-updates" className="mt-6 card p-4">
    <h3 className="font-display font-semibold text-sm">Latest updates</h3>
    <ul className="mt-3 space-y-2.5 text-sm">
      {UPDATES.map(([date, text], i) => (
        <li key={i} data-testid={`about-update-${i}`} className="grid grid-cols-[5.5rem,1fr] gap-3">
          <span className="font-mono text-xs pt-0.5" style={{ color: "var(--ink-3)" }}>{date}</span>
          <span style={{ color: "var(--ink-2)" }}>{text}</span>
        </li>
      ))}
    </ul>
  </section>
);

export const AboutSheet = ({ open, onOpenChange }) => (
  <Sheet open={open} onOpenChange={onOpenChange}>
    <SheetContent data-testid="about-sheet" className="overflow-y-auto sm:max-w-md" style={{ background: "var(--surface)" }}>
      <SheetHeader>
        <SheetTitle className="font-display flex items-center gap-2.5">
          <img src="/logo192.png" alt="" className="h-8 w-8" /> About RGA Trainer
        </SheetTitle>
      </SheetHeader>
      <div data-testid="about-text" className="mt-4 space-y-4 text-sm leading-relaxed" style={{ color: "var(--ink-2)" }}>
        <p>RGA Trainer is a free study aid developed by a current RGA Trainee to assist with preparation for the SSSA exam. It is designed to mimic the formal exam template, with allowances for reading time and reminders for candidates to move on to the next question at appropriate intervals.</p>
        <p>The cases, content and format have been modelled in conjunction with ANZCA's relevant publications, including the RGA Handbook and SSSA Sample Exam Questions. Please note that AI has been utilised in the development of this web app, and as such there is the potential for errors or inaccuracies. All clinical information, advice and feedback is provided as a guide only and candidates are encouraged to cross-reference these with their own study material.</p>
      </div>
      <Updates />
    </SheetContent>
  </Sheet>
);
